import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'echarts'
import './assets/font/iconfont.css'
import store from './store/index'
import iconTitle from './components/iconTitle/index.vue'
Vue.component('iconTitle', iconTitle)
import templateTip from './components/templateTip/index.vue'
Vue.component('templateTip', templateTip)
import numTitle from './components/numTitle/index.vue'
Vue.component('numTitle', numTitle)

import VChart from 'vue-echarts'
Vue.component('VChart', VChart)

import moment from 'moment'
Vue.prototype.moment = moment

import FUNC from '@/utils/commonFunc.js'
Vue.prototype.FUNC = FUNC // 全局方法
import COMMON from '@/utils/common.js'
Vue.prototype.COMMON = COMMON // 项目常量

Vue.prototype.$event = new Vue()

Vue.prototype.$store = store

Vue.use(ElementUI, {
    size: 'small',
})
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    next()
})

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
